module.exports = __webpack_public_path__ + "static/media/ic_selection_disable.52bcc9b5.svg";